export default __webpack_public_path__ + "static/media/production_quantity_limits.d740ec4f.svg";